import { withDefaults } from '@warp-drive/legacy/model/migration-support';
import type { WithLegacy } from '@warp-drive/legacy/model/migration-support';
import type { Type } from '@warp-drive/core/types/symbols';

/** Embedded creator data within the content source embed */
export interface UserSourceCreatorEmbed {
  id: string;
  username: string;
  platform: string;
  displayName: string | null;
}

/** Embedded content source data within a user-source resource */
export interface UserSourceContentSourceEmbed {
  id: string;
  url: string;
  platform: string;
  title: string | null;
  description: string | null;
  thumbnailUrl: string | null;
  duration: number | null;
  state: string;
  language: string | null;
  createdAt: string;
  completedAt: string | null;
  itemTypeCounts: Record<string, number> | null;
  creator: UserSourceCreatorEmbed | null;
}

export type UserSource = WithLegacy<{
  dismissed: boolean | null;
  createdAt: string | null;
  contentSource: UserSourceContentSourceEmbed | null;
  [Type]: 'user-sources';
}>;

export const UserSourceSchema = withDefaults({
  type: 'user-sources',
  fields: [
    { name: 'dismissed', kind: 'attribute', type: 'boolean' },
    { name: 'createdAt', kind: 'attribute', type: 'string' },
    { name: 'contentSource', kind: 'attribute', type: 'object' },
  ],
});
